$(document).ready(function() {
  // As soon as a Course, Story, KnowledgeItem, Chapter or Page has been duplicated
  // we wish to remove the spinner automatically, so the user can continue
  // editing without having to refresh the page manually. This should happen
  // regardless of whether the new duplication method is enabled or not.
  //
  // Instead of retrieving the duplication status for each item separately,
  // we retrieve the duplication statuses in bulk.
  //
  // Notice that we keep on polling until no item is being duplicated anymore.

  const urlForDuplicationBulkStatuses = "/duplication/statuses/bulk_statuses.json";
  let allItems                        = [];

  const monitorDuplicationBulkStatuses = function({ pollIntervalInMilliSeconds }) {
    const courseItems        = retrieveItemsFor({ itemType: "course" });
    const functionItems      = retrieveItemsFor({ itemType: "function" });
    const chapterItems       = retrieveItemsFor({ itemType: "chapter" });
    const pageItems          = retrieveItemsFor({ itemType: "page" });
    const managerPresetItems = retrieveItemsFor({ itemType: "manager-preset" });

    allItems = allItems.concat(courseItems);
    allItems = allItems.concat(functionItems);
    allItems = allItems.concat(chapterItems);
    allItems = allItems.concat(pageItems);
    allItems = allItems.concat(managerPresetItems);

    if (allItems.length > 0) {
      retrieveBulkStatuses({ intervalId: null });

      const intervalId = setInterval(function() {
        retrieveBulkStatuses({ intervalId: intervalId });
      }, pollIntervalInMilliSeconds);
    }
    else {
      // No need to monitor at all.
    }
  }

  const retrieveItemsFor = function({ itemType }) {
    let items = []

    const itemIds = $.map($(`.${itemType}-duplicating`), function (element, index) {
      return parseInt($(element).data("item-id"), 10);
    });

    for (const itemId of itemIds) {
      const item = { id: itemId, type: itemType, data_copied: false }

      items.push(item);
    }

    return items;
  }

  const enableItem = function({ itemType, itemId }) {
    const item    = $(`.${itemType}-duplicating[data-item-id="${itemId}"]`);
    const spinner = $(`.${itemType}-duplicating-spinner[data-item-id="${itemId}"]`);

    item.css("opacity", "1");
    item.css("pointerEvents", "all");

    spinner.hide();
  }

  const retrieveBulkStatuses = function({ intervalId }) {
    const payload = {
      course_ids:         selectItemidsFor({ itemType: "course" }),
      function_ids:       selectItemidsFor({ itemType: "function" }),
      chapter_ids:        selectItemidsFor({ itemType: "chapter" }),
      page_ids:           selectItemidsFor({ itemType: "page" }),
      manager_preset_ids: selectItemidsFor({ itemType: "manager-preset" }),
    }

    $.ajax({
      url:         urlForDuplicationBulkStatuses,
      method:      "POST",
      dataType:    "json",
      contentType: "application/json",
      data:        JSON.stringify(payload),
    }).done(function(data) {
      const items                         = data;
      let itemsForWhichWeNeedStatusUpdate = [];

      for (const item of items) {
        if (item.data_copied) {
          try {
            enableItem({ itemType: item.type, itemId: item.id });
          }
          catch (error) {
            console.log(error);
          }
        }
        else {
          itemsForWhichWeNeedStatusUpdate.push(item);
        }
      }

      allItems = itemsForWhichWeNeedStatusUpdate;

      if (allItems.length === 0 && intervalId) {
        // We can stop polling and don't need to retrieve the bulk
        // statuses since all items have been duplicated.

        clearInterval(intervalId);
      }
    }).fail(function(error) {
      console.log(error);
    });
  }

  const selectItemidsFor = function({ itemType }) {
    let itemIds = []

    for (const item of allItems) {
      if (item.type === itemType ) {
        itemIds.push(item.id);
      }
    }

    return itemIds;
  }

  monitorDuplicationBulkStatuses({ pollIntervalInMilliSeconds: 5000 });
});
